/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page2_GatewaysInputs */



/**
* | output |
* | --- |
* | "Gateways requiring intervention" |
*
* @param {Intervention_Plan_Pdf_Page2_GatewaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page2_gateways = /** @type {((inputs?: Intervention_Plan_Pdf_Page2_GatewaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page2_GatewaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Gateways requiring intervention")
	return /** @type {LocalizedString} */ ("Liste des box nécessitant une intervention")
});